export default {"src":"/_next/static/image/public/images/ic_mypackage_blue.bc6c69ec69aa210d23bc44cab9ab6037.svg","height":15,"width":18};